<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>26年国内M9活动审核</span>
                </div>
            </div>
            <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <el-tab-pane label="新品分享返现" name="new"></el-tab-pane>
                <el-tab-pane label="老盆友专享" name="old"></el-tab-pane>
                <el-tab-pane label="邀请好友" name="invite"></el-tab-pane>
            </el-tabs>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="手机号" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="订单号" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.order_no"></el-input>
                    </el-form-item>
                    <el-form-item label="审核状态" class="form_item">
                        <el-select v-model="searchData.status" placeholder="不限" clearable>
                            <el-option label="审核中" value="0"></el-option>
                            <el-option label="已通过" value="1"></el-option>
                            <el-option label="未通过" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提交时间" class="form_item" width="200">
                        <DatePicker :date="timeRange" :clearable="true" @dateSelect="dateSelect" ></DatePicker>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportList" v-if="roleCheck('105-105-101-103')">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 邀请好友：发券统计 + 批量发券 -->
            <div class="invite_stat_box" v-if="activeTab === 'invite'">
                <div class="stat_item">
                    <p class="stat_num gray">{{ inviteStats.pending_verify }}</p>
                    <p class="stat_label">订单未核验</p>
                </div>
                <div class="stat_item">
                    <p class="stat_num yellow">{{ inviteStats.need_to_issue }}</p>
                    <p class="stat_label">待发券</p>
                </div>
                <div class="stat_item">
                    <p class="stat_num blue">{{ inviteStats.issued }}</p>
                    <p class="stat_label">已发券</p>
                </div>
                <div class="stat_item">
                    <p class="stat_num">{{ inviteStats.total }}</p>
                    <p class="stat_label">邀约总数</p>
                </div>
                <div class="button" :class="{ disabled: selectedIds.length === 0 }" @click="batchIssue">
                    <span>批量标记已发券({{ selectedIds.length }})</span>
                </div>
                <p class="issue_note">邀请好友发券不走人工审核，审核中/未通过的记录可直接勾选标记发券。</p>
            </div>

            <el-table
                highlight-current-row
                :data="listData"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column v-if="activeTab === 'invite'" type="selection" width="45" :selectable="canIssue"></el-table-column>
                <el-table-column prop="id" label="ID" width="70"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="120"></el-table-column>
                <el-table-column label="类型" width="110">
                    <template slot-scope="scope">
                        <span>{{ typeMap[scope.row.type] || scope.row.type }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单号" min-width="180" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="activeTab === 'old'" prop="channel" label="渠道" width="90"></el-table-column>
                <el-table-column v-if="activeTab === 'new'" label="小红书笔记" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-if="scope.row.note_url" :href="scope.row.note_url" target="_blank" class="link">查看笔记</a>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="activeTab !== 'invite'" label="截图" width="90">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.screenshot"
                            style="width: 50px; height: 50px;"
                            fit="cover"
                            :src="scope.row.screenshot"
                            :preview-src-list="[scope.row.screenshot]">
                        </el-image>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="奖励/原因" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="{ unpass: scope.row.status === 2 }">{{ scope.row.reward || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" width="90">
                    <template slot-scope="scope">
                        <span class="finish" v-if="scope.row.status === 0">审核中</span>
                        <span class="send" v-if="scope.row.status === 1">已通过</span>
                        <span class="unshipped" v-if="scope.row.status === 2">未通过</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单核验" width="100">
                    <template slot-scope="scope">
                        <span class="send" v-if="scope.row.order_verified === 1">已核验</span>
                        <span class="gray" v-else>未核验</span>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="审核人" min-width="100"></el-table-column>
                <el-table-column label="提交时间" min-width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.create_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <div class="action_row">
                            <!-- 审核中（非 invite）：快速通过 / 驳回 -->
                            <template v-if="scope.row.type !== 'invite' && scope.row.status === 0 && roleCheck('105-105-101-102')">
                                <div class="button text pass" @click="quickPass(scope.row)">通过</div>
                                <div class="button text reject" @click="openReject(scope.row, false)">驳回</div>
                            </template>
                            <!-- 已通过（非 invite）：撤销 -->
                            <template v-if="scope.row.type !== 'invite' && scope.row.status === 1 && roleCheck('105-105-101-102')">
                                <div class="button text reject" @click="openReject(scope.row, true)">撤销</div>
                            </template>
                            <!-- 已通过（invite）：撤销发券 -->
                            <template v-if="scope.row.type === 'invite' && scope.row.status === 1 && roleCheck('105-105-101-102')">
                                <div class="button text reject" @click="revokeInviteIssue(scope.row)">撤销发券</div>
                            </template>
                            <!-- 详情：任何状态可看 -->
                            <div class="button text" @click="openDetail(scope.row)">详情</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>

        <!-- 详情弹窗（只读） -->
        <Gh-Dialog ref="detailDialog" title="审核详情">
            <template v-slot:content>
                <el-form label-width="110px" v-if="auditData.id">
                    <el-form-item label="记录ID">
                        <span>{{ auditData.id }}</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <span>{{ auditData.phone }}</span>
                    </el-form-item>
                    <el-form-item label="类型">
                        <span>{{ typeMap[auditData.type] || auditData.type }}</span>
                    </el-form-item>
                    <el-form-item label="订单号" v-if="auditData.order_no">
                        <span>{{ auditData.order_no }}</span>
                    </el-form-item>
                    <el-form-item label="订单核验">
                        <span class="send" v-if="auditData.order_verified === 1">已核验</span>
                        <span class="gray" v-else>未核验（等待系统查单）</span>
                    </el-form-item>
                    <el-form-item label="渠道" v-if="auditData.channel">
                        <span>{{ auditData.channel }}</span>
                    </el-form-item>
                    <el-form-item label="小红书笔记" v-if="auditData.note_url">
                        <a :href="auditData.note_url" target="_blank" class="link">{{ auditData.note_url }}</a>
                    </el-form-item>
                    <el-form-item label="截图" v-if="auditData.screenshot">
                        <el-image
                            style="width: 120px; height: 120px;"
                            fit="contain"
                            :src="auditData.screenshot"
                            :preview-src-list="[auditData.screenshot]">
                        </el-image>
                    </el-form-item>
                    <el-form-item label="收货姓名" v-if="auditData.name">
                        <span>{{ auditData.name }}</span>
                    </el-form-item>
                    <el-form-item label="收货地址" v-if="auditData.address">
                        <span>{{ auditData.address }}</span>
                    </el-form-item>
                    <el-form-item label="当前状态">
                        <span class="finish" v-if="auditData.status === 0">审核中</span>
                        <span class="send" v-if="auditData.status === 1">已通过</span>
                        <span class="unshipped" v-if="auditData.status === 2">未通过</span>
                    </el-form-item>
                    <el-form-item :label="auditData.status === 2 ? '失败原因' : '奖励文案'">
                        <span>{{ auditData.reward || '--' }}</span>
                    </el-form-item>
                    <el-form-item label="内部备注" v-if="auditData.remark">
                        <span>{{ auditData.remark }}</span>
                    </el-form-item>
                    <el-form-item label="审核人">
                        <span>{{ auditData.operator || '--' }}</span>
                    </el-form-item>
                    <el-form-item label="审核时间" v-if="auditData.audit_time">
                        <span>{{ auditData.audit_time }}</span>
                    </el-form-item>
                </el-form>
            </template>
            <template v-slot:confirm_btn>
                <!-- 仅审核中（非 invite）且具备审核权限时提供快捷操作 -->
                <div class="action_row" v-if="canQuickAudit">
                    <div class="button confirm" :class="{ disabled: auditSubmitting }" @click="quickPass(auditData, true)">通过</div>
                    <div class="button del" @click="rejectFromDetail">驳回</div>
                </div>
                <div v-else></div>
            </template>
        </Gh-Dialog>

        <!-- 驳回 / 撤销弹窗 -->
        <Gh-Dialog ref="rejectDialog" :title="rejectForm.isRevoke ? '撤销通过' : '驳回记录'" @dialogBack="submitReject">
            <template v-slot:content>
                <el-form label-width="110px" :model="rejectForm">
                    <el-form-item label="记录ID">
                        <span>{{ rejectForm.id }}</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <span>{{ rejectForm.phone }}</span>
                    </el-form-item>
                    <el-form-item label="当前状态">
                        <span class="finish" v-if="rejectForm.fromStatus === 0">审核中</span>
                        <span class="send" v-if="rejectForm.fromStatus === 1">已通过</span>
                        <span class="unshipped" v-if="rejectForm.fromStatus === 2">未通过</span>
                    </el-form-item>
                    <el-form-item label="操作说明" v-if="rejectForm.isRevoke">
                        <span class="tip_text">撤销后该记录将变更为「未通过」，撤销操作不可恢复。</span>
                    </el-form-item>
                    <el-form-item :label="rejectForm.isRevoke ? '撤销原因' : '不通过原因'" required>
                        <el-input type="textarea" :rows="2" v-model="rejectForm.reward" placeholder="必填，将展示给用户"></el-input>
                    </el-form-item>
                    <el-form-item label="内部备注">
                        <el-input type="textarea" :rows="2" v-model="rejectForm.remark" placeholder="选填，仅审核员可见"></el-input>
                    </el-form-item>
                    <el-form-item v-if="rejectForm.isRevoke">
                        <el-checkbox v-model="rejectForm.confirmRevoke">我确认撤销该记录的通过状态</el-checkbox>
                    </el-form-item>
                </el-form>
            </template>
            <template v-slot:confirm_btn>
                <div class="button confirm" :class="{ disabled: auditSubmitting }" @click="submitReject">
                    <span>{{ auditSubmitting ? '提交中...' : '提交' }}</span>
                </div>
            </template>
        </Gh-Dialog>

        <Tip ref="tip" title="导出审核明细" msg="将按当前筛选条件导出 Excel，确认要导出吗？">
            <template v-slot:confirm_btn>
                <div class="button del" @click="exportListConfirm">
                    <span>确定</span>
                </div>
            </template>
        </Tip>
    </div>
</template>
<script>
export default({
    name: 'm9-audit',
    data() {
        return {
            activeTab: 'new',
            searchData: {
                id: '',
                phone: '',
                order_no: '',
                type: 'new',
                status: '',
                start_time: '',
                end_time: '',
                page: 1,
                page_size: 10
            },
            timeRange: [],
            listData: [],
            total: 0,
            typeMap: {
                new: '新品分享返现',
                old: '老盆友专享',
                invite: '邀请好友'
            },
            inviteStats: {
                pending_verify: 0,
                need_to_issue: 0,
                issued: 0,
                total: 0
            },
            selectedIds: [],
            auditData: {},          // 详情弹窗数据（只读）
            rejectForm: {           // 驳回 / 撤销表单
                id: '',
                phone: '',
                fromStatus: 0,       // 发起操作时的记录状态，用于提交前校验
                isRevoke: false,     // true=撤销已通过，false=驳回审核中
                reward: '',
                remark: '',
                confirmRevoke: false
            },
            auditSubmitting: false  // 防连点
        }
    },
    computed: {
        // 详情弹窗是否展示快捷审核按钮：仅审核中且非 invite
        canQuickAudit() {
            return this.auditData.id
                && this.auditData.type !== 'invite'
                && this.auditData.status === 0
                && this.roleCheck('105-105-101-102');
        }
    },
    activated() {
        this.getList();
    },
    methods: {
        handleTabChange() {
            this.searchData.type = this.activeTab;
            this.searchData.page = 1;
            this.getList();
            if (this.activeTab === 'invite') {
                this.getInviteStats();
            }
        },
        dateSelect(date) {
            this.timeRange = date ? [...date] : [];
            if (date && date.length === 2) {
                this.searchData.start_time = this.formDate(date[0], 'YYYY-MM-DD HH:mm:ss');
                this.searchData.end_time = this.formDate(date[1], 'YYYY-MM-DD HH:mm:ss');
            } else {
                this.searchData.start_time = '';
                this.searchData.end_time = '';
            }
        },
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getList() {
            this.api.getLoyaltyOpList(this.searchData).then(data => {
                this.listData = data.data.list || [];
                this.total = data.data.total || 0;
            })
        },
        getInviteStats() {
            this.api.loyaltyInviteStats().then(data => {
                this.inviteStats = data.data || this.inviteStats;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        handleSelectionChange(rows) {
            this.selectedIds = rows.map(r => r.id);
        },
        canIssue(row) {
            // 仅审核中 / 未通过的可被勾选批量发券（邀请好友发券不走人工审核）
            return row.status === 0 || row.status === 2;
        },
        batchIssue() {
            if (this.selectedIds.length === 0) {
                this.$message('请先勾选待发券记录');
                return;
            }
            this.$confirm(`确认将选中的 ${this.selectedIds.length} 条记录标记为已发券？`, '批量发券', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.loyaltyInviteIssue({ ids: this.selectedIds }).then(data => {
                    this.$message.success(`已标记 ${data.data.issued} 条`);
                    this.getList();
                    this.getInviteStats();
                });
            }).catch(() => {});
        },
        // 详情（只读）
        openDetail(row) {
            this.auditData = {};
            this.api.getLoyaltyOpDetail({ id: row.id }).then(data => {
                this.auditData = data.data || {};
                this.$refs.detailDialog.show = true;
            })
        },
        // 快速通过：fromDetail=true 表示从详情弹窗发起，成功后需关闭详情
        quickPass(row, fromDetail = false) {
            if (this.auditSubmitting) return;
            this.$confirm(`确认通过记录 ${row.phone}（${row.order_no}）？`, '快速通过', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.doAudit({
                    id: row.id,
                    status: 1,
                    fromStatus: 0
                }, () => {
                    if (fromDetail) this.$refs.detailDialog.show = false;
                });
            }).catch(() => {});
        },
        // 打开驳回 / 撤销弹窗
        openReject(row, isRevoke) {
            this.rejectForm = {
                id: row.id,
                phone: row.phone,
                fromStatus: row.status,
                isRevoke: !!isRevoke,
                reward: '',
                remark: '',
                confirmRevoke: false
            };
            this.$refs.rejectDialog.show = true;
        },
        // 从详情弹窗发起驳回
        rejectFromDetail() {
            if (!this.auditData.id) return;
            const row = {
                id: this.auditData.id,
                phone: this.auditData.phone,
                status: this.auditData.status
            };
            this.$refs.detailDialog.show = false;
            this.openReject(row, false);
        },
        submitReject() {
            if (this.auditSubmitting) return;
            if (!this.rejectForm.reward || !this.rejectForm.reward.trim()) {
                this.$message.error(this.rejectForm.isRevoke ? '请填写撤销原因' : '未通过时请填写原因');
                return;
            }
            if (this.rejectForm.isRevoke && !this.rejectForm.confirmRevoke) {
                this.$message.error('请先勾选确认撤销');
                return;
            }
            this.doAudit({
                id: this.rejectForm.id,
                status: 2,
                reward: this.rejectForm.reward.trim(),
                remark: this.rejectForm.remark ? this.rejectForm.remark.trim() : '',
                fromStatus: this.rejectForm.fromStatus
            }, () => {
                this.$refs.rejectDialog.show = false;
            });
        },
        // invite 已通过：撤销发券（标记未通过）
        revokeInviteIssue(row) {
            if (this.auditSubmitting) return;
            this.$confirm(`确认撤销记录 #${row.id}（${row.phone}）的发券？撤销后该记录将变更为「未通过」。`, '撤销发券', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.doAudit({
                    id: row.id,
                    status: 2,
                    reward: '撤销发券',
                    fromStatus: 1
                });
            }).catch(() => {});
        },
        // 统一审核提交入口：带防连点 + 前端状态校验兜底
        doAudit(payload, onSuccess) {
            if (this.auditSubmitting) return;
            // 提交前校验：列表中该记录的当前状态是否仍允许本次操作（0→通过/驳回，1→撤销）
            const row = this.listData.find(r => r.id === payload.id);
            if (row && row.status !== payload.fromStatus) {
                this.$message.error('记录状态已变更，请刷新列表后重试');
                this.getList();
                if (this.activeTab === 'invite') this.getInviteStats();
                return;
            }
            // 只传实际需要提交的字段，避免空值覆盖原有数据
            const data = { id: payload.id, status: payload.status };
            if (payload.reward) data.reward = payload.reward;
            if (payload.remark) data.remark = payload.remark;
            this.auditSubmitting = true;
            // 兜底：http 封装在业务失败/网络错误时 Promise 不落定，超时后自动解锁，避免按钮永久禁用
            const submitTimer = setTimeout(() => {
                this.auditSubmitting = false;
            }, 10000);
            this.api.loyaltyOpAudit(data).then(res => {
                clearTimeout(submitTimer);
                this.auditSubmitting = false;
                if (res.code === 200) {
                    this.$message.success('操作成功！');
                    if (typeof onSuccess === 'function') onSuccess();
                    this.getList();
                    if (this.activeTab === 'invite') this.getInviteStats();
                }
            })
        },
        exportList() {
            this.$refs.tip.show = true;
        },
        exportListConfirm() {
            this.api.exportLoyaltyOpList(this.searchData).then(() => {
                this.$refs.tip.show = false;
            });
        }
    }
})
</script>
<style lang="less" scoped>
    .finish{
        color: #F8AF0C;
    }
    .send{
        color: #2A79FF;
    }
    .unshipped{
        color: #F56C6C;
    }
    .gray{
        color: #909399;
    }
    .unpass{
        color: #F56C6C;
    }
    .link{
        color: #2A79FF;
        word-break: break-all;
    }
    .tip_text{
        color: #909399;
        font-size: 12px;
    }
    .action_row{
        display: flex;
        align-items: center;
        .button{
            margin-right: 4px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
    .button.text.pass{
        color: #2A79FF;
    }
    .button.text.reject{
        color: #F56C6C;
    }
    .button.disabled{
        opacity: 0.5;
        pointer-events: none;
    }
    .invite_stat_box{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 16px 20px;
        margin-bottom: 16px;
        background: #f7f9fc;
        border-radius: 8px;
        .stat_item{
            min-width: 90px;
            text-align: center;
            .stat_num{
                font-size: 24px;
                font-weight: 600;
                color: #303133;
                line-height: 1.2;
            }
            .stat_label{
                font-size: 12px;
                color: #909399;
                margin-top: 4px;
            }
            .stat_num.yellow{ color: #F8AF0C; }
            .stat_num.blue{ color: #2A79FF; }
            .stat_num.gray{ color: #909399; }
        }
        .button{
            margin-left: auto;
        }
        .button.disabled{
            opacity: 0.5;
            pointer-events: none;
        }
        .issue_note{
            width: 100%;
            margin: 0;
            font-size: 12px;
            color: #909399;
        }
    }
    .el-image{
        border-radius: 4px;
    }
  /deep/ .search_box .el-form.form-list .form_item .el-form-item__content .el-input__inner{
    width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/view/product/m9/audit.vue